module.exports = __webpack_public_path__ + "static/media/prem-bg.6a3cbc8e.png";